import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {Route, Switch, Redirect} from 'react-router-dom'
import {applyMiddleware, combineReducers, createStore, compose} from 'redux'
import {Provider} from 'react-redux'
import thunk from 'redux-thunk'
import {autoRehydrate, persistStore} from 'redux-persist'
import moment from 'moment'
import 'moment/locale/it'

import fetch from './redux/middlewares/fetch'
import redirect from './redux/middlewares/redirect'
import SostaOnlineApiService from './services/SostaOnlineApiService'
import * as reducers from './redux/modules'
import Notifications from 'react-notify-toast'

import LoadingComponent from './components/LoadingComponent'
import MainNavigatorScreen from './screens/MainNavigatorScreen'
import UserMainContainer from './containers/UserMainContainer'
import BackOfficeContainer from './containers/BackOfficeContainer'
import SplashContainer from './containers/Splash/SplashContainer'
import RegistrationContainer from './containers/Registration/RegistrationContainer'
import PasswordRecoveryContainer from './containers/PasswordRecoveryContainer'
import FakeRegistration from './containers/Registration/FakeRegistration'

import 'react-table/react-table.css'
import 'react-select/dist/react-select.css'
import './App.css'
import CookiePolice from './containers/Cookie/CookiePolice'
import Privacy from './containers/Privacy/Privacy'

const reducer = combineReducers(reducers)
const store = createStore(
  reducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  compose(
    applyMiddleware(fetch, redirect, thunk),
    autoRehydrate()))

moment.locale('it')

const isUserAdminOrOperator = (user) => {
  if (!user) {
    return false
  }

  if (user.role === 'admin' || user.role === 'operator') {
    return true
  }

  return false
}

export default class App extends Component {
  constructor (props) {
    super(props)
    this.state = {
      rehydrated: false,
      initialized: false
    }
  }

  initializePersistor () {
    this.persistor = persistStore(store, {
      blacklist: [
        'form',
        'markRules',
        'markTypes',
        'address',
        'area'
      ]
    }, () => {
      this.setState({rehydrated: true})
      this.initializeState()
    })
  }

  initializeState () {
    if (!store.getState().auth.token) {
      this.setState({initialized: true})
      return
    }

    SostaOnlineApiService.setToken(store.getState().auth.token)
    this.setState({initialized: true})
  }

  componentWillMount () {
    moment.locale('it')
    /* SostaOnlineApiService.eventEmitter.on('auth-error', () => {
            store.dispatch(actions.auth.doLogout());
        }); */
    this.initializePersistor()
  }

  render () {
    if (!this.state.initialized || !this.state.rehydrated) {
      return (<LoadingComponent />)
    }
    return (
      <Provider store={store}>
        <MainNavigatorScreen auth={store.getState().auth}>
          <Notifications />
          <Switch>
            <Route path="/privacy" component={Privacy} />
            <Route path="/cookie-police" component={CookiePolice} />
            <OnlyPublicRoute path="/splash" component={SplashContainer} />
            {/* <OnlyPublicRoute path="/register" component={RegistrationContainer} /> */}
            <OnlyPublicRoute path="/register" component={FakeRegistration} />
            <OnlyPublicRoute path="/forgot-password" component={PasswordRecoveryContainer} />
            <AdministrationRoute path="/backoffice" component={BackOfficeContainer} />
            <PrivateRoute path="/user-area" component={UserMainContainer} />
            <Redirect to={isUserAdminOrOperator(store.getState().auth.user) ? '/backoffice' : '/user-area'} />
          </Switch>
        </MainNavigatorScreen>
      </Provider>
    )
  }
}
// eslint-disable-next-line react/prop-types
export const AdministrationRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (
    (isUserAdminOrOperator(store.getState().auth.user)) ? (
      <Component {...props} />
    ) : (
      <Redirect to={{
        pathname: '/splash',
        // eslint-disable-next-line react/prop-types
        state: { from: props.location }
      }} />
    )
  )} />
)

// eslint-disable-next-line react/prop-types
export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (
    (store.getState().auth.token) ? (
      <Component {...props} />
    ) : (
      <Redirect to={{
        pathname: '/splash',
        // eslint-disable-next-line react/prop-types
        state: { from: props.location }
      }} />
    )
  )} />
)
// eslint-disable-next-line react/prop-types
export const OnlyPublicRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (
    !store.getState().auth.token ? (
      <Component {...props} />
    ) : (<Redirect to={{
      pathname: '/',
      // eslint-disable-next-line react/prop-types
      state: { from: props.location }
    }} />)
  )} />
)



// WEBPACK FOOTER //
// ./src/App.js